import { PageLayout } from '@/components/page-layout';
import { OPTIMIZER_BANNER_ID } from '@/constants/shared';
import { useHomeBanner } from '@/hooks/useHomeBanner';
import { useEffect } from 'react';
import { AllStrategies } from './AllStrategies';
import { Hero } from './Hero';

export const Optimizer = () => {
  const { dismissBannerId } = useHomeBanner();
  useEffect(() => {
    dismissBannerId(OPTIMIZER_BANNER_ID);
  }, [dismissBannerId]);

  return (
    <PageLayout header={null}>
      <Hero />
      <AllStrategies />
    </PageLayout>
  );
};
